import { path, pathOr } from 'ramda';
import { getIsABypassMessageInformation } from '../util/api';

// Sauvegarde l'historique des tentatives de bypass dans le profil utilisateur
export const setBypassAttemptInUserHistory = async (
  sdk,
  getState,
  txId,
  contentRaw,
  bypassMessageInformation
) => {
  try {
    const userState = getState().user;
    const currentUser = userState.currentUser;
    const bypassAttemptsHistory = pathOr(
      [],
      ['attributes', 'profile', 'privateData', 'bypassAttemptsHistory'],
      currentUser
    );
    await sdk.currentUser.updateProfile({
      privateData: {
        bypassAttemptsHistory: [
          ...bypassAttemptsHistory,
          {
            ...bypassMessageInformation,
            transactionId: txId,
            contentRaw,
            date: new Date().toISOString(),
          },
        ],
      },
    });
  } catch (e) {
    // On ne bloque pas l'utilisateur si l'historique ne peut pas être enregistré
  }
};

// Vérifie si un message contient une tentative de bypass ou un cas "événement"
// Retourne true si ok, lève une erreur structurée si blocage.
export const verifyMessageForBypass = async (
  sdk,
  getState,
  { txId, messageRaw, token, dontAnalyseContent = false }
) => {
  if (dontAnalyseContent) return true;

  try {
    const response = await getIsABypassMessageInformation(
      {
        text: messageRaw,
        transactionId: txId,
      },
      token
    );

    const bypassMessageInformation = {
      isEvent: path(['isEvent'], response),
      isBypassing: path(['isBypassing'], response),
      text: path(['text'], response),
    };

    if (bypassMessageInformation.isEvent) {
      await setBypassAttemptInUserHistory(
        sdk,
        getState,
        txId,
        messageRaw,
        bypassMessageInformation
      );
      throw {
        status: 400,
        name: 'isEvent',
        isBypassing: bypassMessageInformation.isEvent,
        message: 'User is looking to organize an event',
        payload: {
          text: bypassMessageInformation.isEvent,
        },
      };
    }

    if (bypassMessageInformation.isBypassing) {
      await setBypassAttemptInUserHistory(
        sdk,
        getState,
        txId,
        messageRaw,
        bypassMessageInformation
      );
      throw {
        status: 400,
        name: 'bypassing',
        isBypassing: bypassMessageInformation.isBypassing,
        message: 'User is trying to bypass platform',
        payload: {
          text: bypassMessageInformation.isBypassing,
        },
      };
    }

    return true;
  } catch (e) {
    // On laisse remonter uniquement les erreurs de type isEvent ou bypassing
    if (e?.name === 'isEvent') throw e;
    if (e?.name === 'bypassing') throw e;

    // Pour toute autre erreur (réseau, service), on renvoie false
    return false;
  }
};
